export default __webpack_public_path__ + "static/media/034-fossil.37f234b9.svg";